import { render, staticRenderFns } from "./naklodnoyNew.vue?vue&type=template&id=7e98f2db&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./naklodnoyNew.vue?vue&type=script&lang=js"
export * from "./naklodnoyNew.vue?vue&type=script&lang=js"
import style0 from "./naklodnoyNew.vue?vue&type=style&index=0&id=7e98f2db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e98f2db",
  null
  
)

export default component.exports